"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const propertyTypes = [{
  id: 1,
  title: "Foreclosure",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579273/img/foreclosure_house_exterior.png",
  badge: "Foreclosure"
}, {
  id: 2,
  title: "Probate",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579273/img/probate_estate_home.png",
  badge: "Probate"
}, {
  id: 3,
  title: "Fire Damage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579273/img/fire_damaged_property.png",
  badge: "Fire Damage"
}, {
  id: 4,
  title: "Major Repairs",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579273/img/house_needing_major_repairs.png",
  badge: "Major Repairs"
}, {
  id: 5,
  title: "Inherited",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579273/img/inherited_family_home.png",
  badge: "Inherited"
}, {
  id: 6,
  title: "Distressed",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579273/img/distressed_property_exterior.png",
  badge: "Distressed"
}];
export default function AnyHouseAnyCondition() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="any-house-any-condition" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerReveal.ref} className={`max-w-3xl mx-auto text-center mb-12 md:mb-16 transition-all duration-700 ease-out ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground mb-4">
            We Buy Houses in Any Condition
          </h2>
          <p className="text-lg text-muted-foreground">
            From pristine estates to properties needing major overhauls, we make
            fair cash offers regardless of the situation. No repairs or cleaning
            required.
          </p>
        </div>

        <div ref={gridReveal.ref} className={`columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6 transition-all duration-1000 ease-out delay-200 ${gridReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {propertyTypes.map((item, i) => <div key={item.id} data-index={i} className="break-inside-avoid relative group overflow-hidden rounded-xl shadow-md bg-muted">
              <img src={item.image} alt={item.title} className="w-full h-auto object-cover transition-transform duration-700 ease-in-out group-hover:scale-105" loading="lazy" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

              <Badge variant="outline" className="absolute top-4 left-4 bg-white text-black border-none shadow-sm font-semibold px-3 py-1 z-10">
                {item.badge}
              </Badge>

              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 backdrop-blur-[2px] bg-black/30 z-20">
                <Button asChild variant="default" size="lg" className="shadow-xl translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  <Link to="#lead-capture">
                    Request Offer <ArrowRight className="ml-2 size-4" />
                  </Link>
                </Button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}